/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/space-bar-1214373': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M21 9a1 1 0 00-1 1v3H4v-3a1 1 0 00-2 0v4a1 1 0 001 1h18a1 1 0 001-1v-4a1 1 0 00-1-1z"/>'
  }
})
